import Vue from 'vue'
import Router from 'vue-router'
// import HomeView from './views/HomeView.vue'
import OverviewView from './views/ParentView.vue'
import Login from '@/components/Login.vue'
import store from './store.js'

Vue.use(Router)

const isAuthenticated = (to, from, next) => {
  if (store.getters.isShowApp) {
    next();
    return;
  }
  next('/login');
}

export default new Router({
  routes: [{
    path: '/login',
    name: 'login',
    component: Login
  }, {
    path: '/',
    name: 'patientAndTestCountOverview',
    component: () =>
      import('./views/OverviewView.vue'),
    beforeEnter: isAuthenticated,
    props: {
      type: ''
    }
  },
  {
    path: '/patientListOverview',
    name: 'patientListOverview',
    component: () =>
      import('./views/OverviewView.vue'),
    beforeEnter: isAuthenticated,
    props: {
      type: 'patientList'
    }
  },
  {
    path: '/register-patient',
    name: 'register-patient',
    component: () =>
      import('./views/RegisterPatientView.vue'),
    beforeEnter: isAuthenticated
  },
  {
    path: '/test-result',
    name: 'test-result',
    component: () =>
      import('./views/TestResultView.vue'),
    beforeEnter: isAuthenticated
  },
  {
    path: '/component-test',
    name: 'component-test',
    component: () =>
      import('./views/ComponentTestView.vue'),
    beforeEnter: isAuthenticated
  },
  {
    path: '/files-upload',
    name: 'files-upload',
    component: () =>
      import('./views/FilesUploadView.vue'),
    beforeEnter: isAuthenticated
  },
  {
    path: '/report-template',
    name: 'report-template',
    component: () =>
      import('./views/ReportTemplateView.vue'),
    beforeEnter: isAuthenticated
  },
  {
    path: '/analytic',
    name: 'analytic',
    component: () =>
      import('./views/AnalyticView.vue'),
    beforeEnter: isAuthenticated
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import( /* webpackChunkName: "about" */ './views/AboutView.vue'),
    beforeEnter: isAuthenticated
  }
  ]
})